import { useTranslation } from 'react-i18next'

import {
  BuildingMultiSelect,
  BuildingSelectFormikField,
} from '../../../../Building'
import { FieldStackedLabel } from '../../../../Field'
import { getMappingRowBuildingsName } from '../EditBuildingAndCategoryModalFormFields.utils'

import * as styles from '../EditBuildingAndCategoryModalFormFields.module.css'

function BuildingField({ index, isLoading, isSubmitting }) {
  const { t } = useTranslation()

  return (
    <div className={styles.column}>
      <BuildingSelectFormikField
        multi
        Field={FieldStackedLabel}
        Select={BuildingMultiSelect}
        controlProps={{
          contentProps: {
            inputProps: {
              placeholder: t('Provider.FormBuildingFieldPlaceholderKey'),
            },
          },
        }}
        disabled={isSubmitting}
        fieldComponentProps={{
          isLoading,
          label: t('Provider.FormBuildingFieldLabelKey'),
        }}
        name={getMappingRowBuildingsName(index)}
      />
    </div>
  )
}

export default BuildingField
